import { FontIcon, Icon } from "@fluentui/react";
import { ColumnsType } from "antd/es/table";
import IsDataNull from "../../Template/IsDataNull";
import SortIcon from "../../Template/SortIcon";
import NameLink from "../../Template/NameLink";
import { Tooltip } from "antd";
import { useNavigate } from "react-router";
import DocumentDetailNavigationButton from "./DocumentDetailNavigationButton";
import { useDispatch } from "react-redux";
import ActionColumn from "./ActionColumn";
import ShortenedName from "./ShortenedName";
import TableHeader from "./TableHeader";

export interface EngageTranslationNewTableColumnProperties {
  id: number;
  documentId: number;
  name: string;
  engageProductionId: string;
  format: string;
  pages: number;
  client: string;
  sourceLanguage: string;
  outputLanguage: string;
  isLock: boolean;
  assignedTo: string;
  status: "New" | "Processing" | "Failed" | "QC Ready" | "QC in Progress";
}
const EngageTranslationNewTableColumns: ColumnsType<EngageTranslationNewTableColumnProperties> = [
  {
    title: <TableHeader title="ID" />,
    dataIndex: "displayId",
    key: "id",
    sorter: true,
    defaultSortOrder: "descend",
    width: 80,
  },
  {
    title: <TableHeader title="Document" />,
    dataIndex: "name",
    key: "name",
    sorter: true,
    width: "8%",
    render: (data) => {
      const maxLength = 30;

      if (data.length > maxLength) {
        return (
          <ShortenedName
            data={data}
            maxLength={maxLength}
            toolTipText={data}
          />
        );
      } else {
        return <IsDataNull data={data} />;
      }
    },
  },
  {
    title: <TableHeader title="Engage ID" />,
    dataIndex: "engageProductionId",
    key: "engageProductionId",
    sorter: true,
    width: 100,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Format" />,
    dataIndex: "format",
    key: "format",
    sorter: true,
    width: 100,
    render: (data) => {
      if (data === "pdf") {
        return <FontIcon iconName="PDF" />;
      } else if (data === "docx" || "doc") {
        return <FontIcon iconName="WordDocument" />;
      } else {
        <IsDataNull data={data} />;
      }
    },
  },
  {
    title: <TableHeader title="Client" />,
    dataIndex: "client",
    sorter: true,
    width: 100,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Source Language" />,
    dataIndex: "sourceLanguage",
    key: "sourceLanguage",
    sorter: true,
    width: 180,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Output Language" />,
    dataIndex: "outputLanguage",
    key: "outputLanguage",
    sorter: true,
    width: 180,
    render: (data) => <IsDataNull data={data} />,
  },
  // {
  //   title: <TableHeader title="Assigned To" />,
  //   key: "qcAssignedTo",
  //   dataIndex: "qcAssignedTo",
  //   width: 150,
  //   sorter: true,
  //   render: (data) => <IsDataNull data={data} />,
  // },
  {
    title: <TableHeader title="Workflow Coordinator" />,
    key: "workflowCoordinator",
    dataIndex: "workflowCoordinator",
    width: 200,
    sorter: true,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Status" />,
    dataIndex: "status",
    key: "status",
    sorter: true,
    width: 90,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <TableHeader title="Actions" />,
    dataIndex: "action",
    key: "action",
    width: 125,
    align: "center",
    render: (value, record) => {
      return (
        <ActionColumn
          type="new"
          record={record}
        />
      );
    },
  },
];

export default EngageTranslationNewTableColumns;
